import router from './router'

router.afterEach((to, from) => {
  if (to.path !== '/') {
    window.scrollTo(0, 0) // 切换路由之后滚动条始终在最顶部
  }
})
